// SEO section — lives on its own admin route (`/admin/seo`). Fields describe
// how the site presents itself to search engines and social sharing.
//
// `default` values are seeded into the Supabase content row on first admin
// load (see ContentContext.jsx), so admins land on a filled-in page instead
// of blank inputs.

export const SEO_DEFAULTS = {
  siteName: "Karen Boley Counselling",
  titleSuffix: " | Karen Boley Counselling",
  defaultDescription:
    "Warm, patient-centred counselling in Delta and Tsawwassen, BC with Karen Boley, MACP, MSEd, CCC. Support for anxiety, depression, burnout, OCD, perinatal issues, neurodivergence and couples. Book a free 20-minute consultation.",
  defaultOgImage: "/og-image.jpg",
  businessDescription:
    "Karen Boley Counselling offers warm, patient-centred therapy in Delta and Tsawwassen, BC. Karen supports adults, couples and families through anxiety, depression, burnout, OCD, perinatal challenges, neurodivergence and life transitions. In-person and online sessions available, with a free 20-minute consultation.",
  pages: {
    home: {
      title:
        "Karen Boley Counselling | Registered Therapist in Delta & Tsawwassen, BC",
      description:
        "Compassionate counselling in Delta & Tsawwassen, BC for anxiety, depression, burnout, OCD, perinatal issues, neurodivergence and couples. Book a free 20-minute consultation with Karen Boley, MACP, MSEd, CCC.",
    },
    blog: {
      title: "Journal | Karen Boley Counselling — Delta, BC",
      description:
        "Reflections on therapy, growth and everyday life from Karen Boley Counselling in Delta & Tsawwassen, BC.",
    },
  },
};

export const SEO_SCHEMA = [
  {
    key: "site",
    label: "Site defaults",
    description: "Applied everywhere unless a specific page overrides them below.",
    fields: [
      { path: "seo.siteName", label: "Site / business name", type: "text" },
      { path: "seo.titleSuffix", label: "Title suffix (appended to page titles)", type: "text" },
      { path: "seo.defaultDescription", label: "Default meta description", type: "textarea" },
      { path: "seo.defaultOgImage", label: "Default social share image (1200×630 recommended)", type: "image" },
      { path: "seo.businessDescription", label: "Business description for search engines (LocalBusiness schema)", type: "textarea" },
    ],
  },
  {
    key: "home",
    label: "Home page overrides",
    description: "Leave blank to fall back to the site defaults above.",
    fields: [
      { path: "seo.pages.home.title", label: "Home page — SEO title", type: "text" },
      { path: "seo.pages.home.description", label: "Home page — meta description", type: "textarea" },
    ],
  },
  {
    key: "blog",
    label: "Blog page overrides",
    description: "Applies to the /blog listing page. Individual posts have their own SEO overrides in the post editor.",
    fields: [
      { path: "seo.pages.blog.title", label: "Blog page — SEO title", type: "text" },
      { path: "seo.pages.blog.description", label: "Blog page — meta description", type: "textarea" },
    ],
  },
];
